module.exports = __webpack_public_path__ + "static/media/item_27_3.2b44319a.png";